import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import { css as _css } from "styled-components";
import { keyframes as _keyframes } from "styled-components";
import _styled from "styled-components";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["animation: ", " 2s ease-out infinite 0.5s;"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  50% {\n    opacity: 0.33;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback, useMemo, useState, useEffect } from "react";
import CompressorIconAsset from "@smartheat/common/png/compressor@112x112.png";
import { ReactComponent as OkayIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/successcircle.svg";
import { formatTemperature } from "../../../../utils/formatTemperature";
import { useRegistersSubscription } from "../../../DeviceData/useRegistersSubscription";
import { useRegisterConfigQuery } from "../../../DeviceData/useRegisterConfigQuery";
import { useAlarms } from "../../../DeviceData/useAlarms";
import { ConfirmModal } from "../../ToggleGroup/ConfirmModal";
import { ConfirmButton } from "../../ToggleGroup/ConfirmButton";
import { useRegSlot, useRegister } from "../../../hooks/useRegister";
import { HeatChillToggle } from "./HeatChillToggle";

var OneCenterElement = _styled.div.withConfig({
  displayName: "Hw2Page__OneCenterElement",
  componentId: "sc-9jr343-0"
})(["position:relative;display:flex;justify-content:center;margin:64px auto 0;width:368px;height:368px;@media screen and (max-width:419px){width:288px;height:288px;margin:40px auto 0;}"]);

var HeatChillContainer = _styled.div.withConfig({
  displayName: "Hw2Page__HeatChillContainer",
  componentId: "sc-9jr343-1"
})(["position:relative;display:flex;justify-content:center;"]);

var CircleElement = _styled.div.withConfig({
  displayName: "Hw2Page__CircleElement",
  componentId: "sc-9jr343-2"
})(["position:absolute;height:320px;width:320px;top:50%;left:50%;transform:translate(-50%,-50%);background-color:", ";border-radius:50%;display:flex;justify-content:center;opacity:", ";@media screen and (max-width:419px){height:240px;width:240px;}"], function (props) {
  return props.hasError ? "#dd4e4e" : "#4d9adf";
}, function (props) {
  return props.disabled ? 0.3 : 1;
});

var CircleContent = _styled.div.withConfig({
  displayName: "Hw2Page__CircleContent",
  componentId: "sc-9jr343-3"
})(["color:white;width:230px;"]);

var CenteredMessage = _styled.div.withConfig({
  displayName: "Hw2Page__CenteredMessage",
  componentId: "sc-9jr343-4"
})(["font-size:36px;text-align:center;display:flex;height:100%;align-items:center;justify-content:center;@media screen and (max-width:419px){font-size:30px;}"]);

var TemperatureLeftRight = _styled.div.withConfig({
  displayName: "Hw2Page__TemperatureLeftRight",
  componentId: "sc-9jr343-5"
})(["display:flex;font-size:28px;width:230px;margin:50px auto 0 auto;div{flex:1 1 50%;text-align:center;}@media screen and (max-width:419px){font-size:22px;width:180px;margin-top:48px;}"]);

var blinkAnimation = _keyframes(_templateObject());

var TemperatureCenter = _styled.div.withConfig({
  displayName: "Hw2Page__TemperatureCenter",
  componentId: "sc-9jr343-6"
})(["display:flex;justify-content:center;margin-top:38px;font-size:46px;", " @media screen and (max-width:419px){font-size:40px;margin-top:20px;}"], function (p) {
  return p.blink ? _css(_templateObject2(), blinkAnimation) : '';
});

var ErrorContent = _styled.div.withConfig({
  displayName: "Hw2Page__ErrorContent",
  componentId: "sc-9jr343-7"
})(["font-size:20px;color:white;width:270px;display:flex;flex-direction:column;align-items:center;justify-content:space-between;"]);

var ErrorMessage = _styled.div.withConfig({
  displayName: "Hw2Page__ErrorMessage",
  componentId: "sc-9jr343-8"
})(["font-size:36px;margin-top:65px;text-align:center;@media screen and (max-width:419px){font-size:30px;margin-top:45px;}"]);

var BlockErrorMessage = _styled.div.withConfig({
  displayName: "Hw2Page__BlockErrorMessage",
  componentId: "sc-9jr343-9"
})(["font-size:30px;margin-top:65px;text-align:center;@media screen and (max-width:419px){font-size:24px;margin-top:45px;}"]);

var ErrorInfo = _styled.div.withConfig({
  displayName: "Hw2Page__ErrorInfo",
  componentId: "sc-9jr343-10"
})(["margin-bottom:48px;@media screen and (max-width:419px){margin-bottom:32px;}"]);

var NumberRow = _styled.div.withConfig({
  displayName: "Hw2Page__NumberRow",
  componentId: "sc-9jr343-11"
})(["font-size:24px;text-align:center;"]);

var TextRow = _styled.div.withConfig({
  displayName: "Hw2Page__TextRow",
  componentId: "sc-9jr343-12"
})(["font-size:22px;text-align:center;@media screen and (max-width:419px){font-size:18px;padding:0 24px;}"]);

var CompressorIndicatorImage = _styled.img.withConfig({
  displayName: "Hw2Page__CompressorIndicatorImage",
  componentId: "sc-9jr343-13"
})(["position:absolute;left:50%;transform:translateX(-50%);top:10px;width:28px;height:28px;"]);

var CompressorIndicator = function CompressorIndicator() {
  return /*#__PURE__*/React.createElement(CompressorIndicatorImage, {
    src: CompressorIconAsset,
    alt: ""
  });
};

var allRegisters = ["motohoursBlockState", "workingMode", "compressorStatus", "seasonMode", "t3", "t3_cold", "t3Sensor", "t4Sensor"];
var sizeIconModal = 60;
export function Hw2Page() {
  var _useRegistersSubscrip = useRegistersSubscription(allRegisters),
      registersData = _useRegistersSubscrip.registersData;

  var registersConfig = useRegisterConfigQuery(allRegisters);
  var motohoursBlockState = registersData.motohoursBlockState,
      workingMode = registersData.workingMode;
  var alarms = useAlarms();

  if (workingMode === undefined || !registersConfig) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, null, /*#__PURE__*/React.createElement(CircleContent, null, /*#__PURE__*/React.createElement(CenteredMessage, null, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."))));
  }

  if (!registersConfig.workingMode) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, null, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(BlockErrorMessage, null, "\u0412\u044B\u043A\u043B."), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(NumberRow, null, "+7(499)704-13-98"), /*#__PURE__*/React.createElement(TextRow, null, "обратитесь в сервисный центр")))));
  }

  if (motohoursBlockState) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, {
      hasError: true
    }, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(BlockErrorMessage, null, "\u0422\u0435\u043F\u043B\u043E\u0432\u043E\u0439 \u043D\u0430\u0441\u043E\u0441 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(NumberRow, null, "+7(499)704-13-98"), /*#__PURE__*/React.createElement(TextRow, null, "обратитесь в сервисный центр")))));
  }

  if (alarms.length > 0) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, {
      hasError: true
    }, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(ErrorMessage, null, "\u041E\u0448\u0438\u0431\u043A\u0430: ", alarms[0]), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(NumberRow, null, "+7(499)704-13-98"), /*#__PURE__*/React.createElement(TextRow, null, "обратитесь в сервисный центр")))));
  }

  return /*#__PURE__*/React.createElement(UserModeContent, {
    registersData: registersData,
    registersConfig: registersConfig
  });
}
var SEASON_MODE_HEAT_VALUE = false;
var SEASON_MODE_CHILL_VALUE = true;

function UserModeContent(_ref) {
  var registersConfig = _ref.registersConfig,
      registersData = _ref.registersData;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      openedModal = _useState2[0],
      setOpenedModal = _useState2[1];

  var t3Heat = useRegister("t3", registersData, registersConfig);
  var t3Chill = useRegister("t3_cold", registersData, registersConfig);
  var t3Sensor = useRegister("t3Sensor", registersData, registersConfig);
  var t4Sensor = useRegister("t4Sensor", registersData, registersConfig);
  var compressorStatus = useRegister("compressorStatus", registersData, registersConfig);
  var seasonModeReg = useRegSlot("seasonMode", registersData, registersConfig);
  var isInHeatMode = seasonModeReg.value === undefined ? undefined : seasonModeReg.value === SEASON_MODE_HEAT_VALUE;

  var onModalClose = function onModalClose() {
    setOpenedModal(null);
  };

  var handleHeatChillChange = function handleHeatChillChange() {
    setOpenedModal(isInHeatMode ? "ConfirmChill" : "ConfirmHeat");
  };

  var handleHeatConfirmed = useCallback(function () {
    setOpenedModal(null);
    seasonModeReg.setValue(SEASON_MODE_HEAT_VALUE);
  }, [seasonModeReg]);
  var handleChillConfirmed = useCallback(function () {
    setOpenedModal(null);
    seasonModeReg.setValue(SEASON_MODE_CHILL_VALUE);
  }, [seasonModeReg]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, null, /*#__PURE__*/React.createElement(CircleContent, null, /*#__PURE__*/React.createElement(TemperatureLeftRight, null, /*#__PURE__*/React.createElement("div", null, formatTemperature(Math.round(t3Sensor))), /*#__PURE__*/React.createElement("div", null, formatTemperature(Math.round(t4Sensor)))), /*#__PURE__*/React.createElement(TemperatureCenter, null, seasonModeReg.value === undefined ? "&nbsp;" : formatTemperature(Math.round(isInHeatMode ? t3Heat : t3Chill)))), compressorStatus && /*#__PURE__*/React.createElement(CompressorIndicator, null))), /*#__PURE__*/React.createElement(HeatChillContainer, null, /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "ConfirmHeat",
    onClose: onModalClose,
    titleText: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0440\u0435\u0436\u0438\u043C?",
    contentText: "\u041D\u0430\u0447\u0430\u0442\u044C \u0442\u043E\u043F\u0438\u0442\u044C \u0441\u0435\u0439\u0447\u0430\u0441"
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: handleHeatConfirmed
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    width: sizeIconModal,
    height: sizeIconModal
  }))), /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "ConfirmChill",
    onClose: onModalClose,
    titleText: "Переключить режим?",
    contentText: "Включить охлаждение"
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: handleChillConfirmed
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    width: sizeIconModal,
    height: sizeIconModal
  }))), /*#__PURE__*/React.createElement(HeatChillToggle, {
    on: isInHeatMode,
    indeterminate: seasonModeReg.value === undefined,
    syncing: seasonModeReg.syncing,
    onChange: handleHeatChillChange
  })));
}